export default __webpack_public_path__ + "static/media/Artboard 14.8f5ef0d8.png";